import { useMemo } from 'react';
import { useStoreState } from '~/store';
import { shipiumNavigationBuilder } from '~/store/navigation/shipiumNavigationBuilder';
import { useSession } from './useSession';

export const useNavigation = () => {
  const { sessionPartnerUrl, partnerOptIns, isShipiumView } = useSession();
  const sessionPartnerRole = useStoreState((state) => state.session.user?.sessionPartnerRole);
  const partnerFeatureToggles = useStoreState((state) => state.partner?.activePartner?.featureToggles);

  return useMemo(
    () =>
      shipiumNavigationBuilder(
        sessionPartnerUrl || 'shipium',
        sessionPartnerRole || 'editor',
        isShipiumView,
        partnerFeatureToggles ?? {},
        partnerOptIns ?? {},
      )
        .filterAllowed()
        .build(),
    [sessionPartnerUrl, sessionPartnerRole, isShipiumView, partnerFeatureToggles, partnerOptIns],
  );
};
